import React, { memo, useEffect } from 'react'
import { CallBackModel, HotCity } from '../interfaces'
import styles from '../index.less'
import { PartOperation } from '../interfaces/enums';
import { TLang ,getCookie} from '@/utils/lang';
interface PropTypes {
  /** 热门城市数据 */
  hotCity: HotCity[]
  /** 事件回调 */
  callBack?: (args: CallBackModel<HotCity>) => any
}
function HotCityPart(props: PropTypes) {
  const { hotCity, callBack } = props;
  const clickCity = (item, cid?: number) => {
    let obj: CallBackModel<HotCity> = {
      data: item,
      type: PartOperation.selectedCity
    };
    callBack && callBack(obj)
  }
  useEffect(() => {
    
  }, [])
  return (
    <div className={styles.hot_city}>
      <h3>{TLang("热门城市",'home',false,false,null)}</h3>
      <ul>
        {
          hotCity
          && hotCity.length > 0
          && hotCity.map((item, index) => (
            <li
              key={index}
              onClick={() => clickCity(item)}
            >
              {getCookie('df_lang')==='en-US'?item.pinyin:item.name}
            </li>
          ))
        }
      </ul>
    </div>
  )
}
export default memo(HotCityPart)
